import React, { FC, ReactElement } from 'react';

import styles from './subscribeCardSellingPointStyles.scss';

const SubscribeCardSellingPoint: FC<{
  header: string;
  subBullets: string[];
}> = ({ header, subBullets }): ReactElement => {
  return (
    <div className={styles.container} key={header}>
      <h2>{header}</h2>
      <ul>
        {subBullets.map(
          (item: string, index: number): ReactElement => {
            return <li key={index}>{item}</li>;
          }
        )}
      </ul>
    </div>
  );
};

export default SubscribeCardSellingPoint;
